import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/app/App";
import { AppBoot } from "@/app/AppBoot";
import { ErrorBoundary } from "@/app/ErrorBoundary";
import { installNativeKeyboardInsets } from "@/app/nativeKeyboardInsets";
import { installNativeRecovery } from "@/app/nativeRecovery";
import { installNativeSafeArea } from "@/app/nativeSafeArea";
import { Providers } from "@/app/Providers";
import { bootstrapThemeBeforeRender } from "@/theme/ThemeProvider";
import "@/styles/tailwind.css";
import "@/styles/index.css";
import "@/styles/home.css";
import "@/styles/racing.css";
import "@/styles/racing-v2.css";
import "@/styles/packs.css";
import "@/styles/player.css";
import "@/styles/leaderboards.css";
import "@/styles/secondary.css";
import "@/styles/cashier.css";
import "@/cashier/payment-methods/payment-methods.css";
import "@/styles/themes/monkeytilt.css";
import "@/styles/themes/monkeytilt-shell.css";
import "@/styles/themes/monkeytilt-wallet.css";
import "@/styles/themes/monkeytilt-cashier.css";
import "@/styles/themes/monkeytilt-auth.css";
import "@/styles/themes/monkeytilt-chat.css";
import "@/styles/themes/monkeytilt-product.css";
import "@/styles/large.css";
import "@/styles/skeletons.css";
import "@/styles/mobile.css";
import "@/styles/quick-rip-mobile.css";
import "@/styles/betslip.css";
import "@/styles/mobile-player-overlay.css";
import "@/styles/player-loading.css";
import "@/styles/market-panel.css";
import "@/styles/schedule.css";

installNativeKeyboardInsets();
installNativeSafeArea();
installNativeRecovery();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root mount");
const reactRoot = createRoot(root);
const preloadedEntry = document.documentElement.classList.contains(
  "app-preloaded-entry",
);

const userAgent = window.navigator.userAgent;
if (
  /AppleWebKit/i.test(userAgent) &&
  !/(Chrome|Chromium|CriOS|Edg|OPR)/i.test(userAgent)
) {
  document.documentElement.dataset.engine = "webkit";
}

if (!preloadedEntry) {
  reactRoot.render(
    <StrictMode>
      <AppBoot />
    </StrictMode>,
  );
}

async function mount() {
  await bootstrapThemeBeforeRender();
  document.documentElement.classList.remove("app-preloaded-entry");
  reactRoot.render(
    <StrictMode>
      <ErrorBoundary>
        <Providers>
          <App />
        </Providers>
      </ErrorBoundary>
    </StrictMode>,
  );
  // Recovery owns its URL counter until lazy route initialization has had
  // a healthy interval. Clearing it immediately could restart the counter
  // on every failed renderer import and turn bounded retries into a loop.
  window.dispatchEvent(new Event("hrw:app-mounted"));
}

void mount();
